import React from "react";
import { cn } from "@/lib/utils";

interface SquareMedalProps {
  rank: number;
  leagueName?: string; // Unused for now, but kept for interface consistency/future use
  size?: "small" | "medium" | "large";
  className?: string;
  title?: string;
}

export default function SquareMedal({
  rank,
  size = "small",
  className,
  title,
}: SquareMedalProps) {
  let bucket = 8;
  if (rank > 50) bucket = 100;
  else if (rank > 25) bucket = 50;
  else if (rank > 8) bucket = 25;

  const src = `/images/medals/bronze${bucket}_square.svg`;

  // Size definitions
  const sizeClasses = {
    small: "w-12 h-12 text-[10px]",
    medium: "w-16 h-16 text-xs",
    large: "w-24 h-24 text-sm",
  };

  const currentSizeClass = sizeClasses[size] || sizeClasses.small;

  return (
    <div className={cn("relative flex items-center justify-center", currentSizeClass, className)}>
      <img src={src} alt={`Rank ${rank} Medal`} className="w-full h-full object-contain" />
      <div className="absolute inset-0 flex flex-col items-center justify-center pt-2 text-[#986A44] font-bold leading-none">
         {/* Adjust pt-2 or text color as needed based on visual inspection of the SVG */}
        <span className="text-[0.6em] opacity-80 uppercase">{title || (size === 'small' ? '' : 'TOP')}</span>
        <span className="text-[1.8em]">{rank}</span>
      </div>
    </div>
  );
}
